export enum CegidExportErrorMotifEnum {
  COMPTE_COMPTABLE_MANQUANT = 'COMPTE_COMPTABLE_MANQUANT',
  TAXE_MANQUANTE = 'TAXE_MANQUANTE'
}

export const CEGID_EXPORT_ERROR_MOTIF_LABELS: Record<CegidExportErrorMotifEnum, string> = {
  [CegidExportErrorMotifEnum.COMPTE_COMPTABLE_MANQUANT]: 'Compte comptable manquant',
  [CegidExportErrorMotifEnum.TAXE_MANQUANTE]:             'Taxe manquante',
};
